(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Domain-based navigation and link modifications
  const currentUrl = window.location.href;
  const currentPath = window.location.pathname;
  const isSilkyMitts = currentUrl.indexOf('shop.silkymittsball.com') !== -1;
  const isFitSwitch = currentUrl.indexOf('fitswitch.io') !== -1;
  const isParadigm = currentUrl.indexOf('shop.paradigmiot.com') !== -1 || currentUrl.indexOf('paradigmiot.myshopify.com') !== -1;

  // Helper: modify all links with a given href
  const modifyHref = function(oldHref, newHref) {
    document.querySelectorAll("a[href='" + oldHref + "']").forEach(function(el) {
      el.href = newHref;
    });
  };

  // Helper: remove elements by class
  const deleteClass = function(className) {
    document.querySelectorAll('.' + className).forEach(function(el) {
      el.remove();
    });
  };

  // Helper: remove nav links by href
  const removeNavLink = function(href) {
    document.querySelectorAll("a[href='" + href + "']").forEach(function(el) {
      if (el.parentNode && el.parentNode.tagName === 'LI') {
        el.parentNode.remove();
      }
    });
  };

  if (isSilkyMitts) {
    // SilkyMitts: Liquid handles the nav, just fix email and search
    modifyHref('mailto:help@fitswitch.io', 'mailto:hockey@silkymittsball.com');
    deleteClass('header__search');
  } else if (isParadigm) {
    // Paradigm IOT domain
    if (currentPath === '/') {
      // Show image_with_text on homepage
      const imageWithText = document.querySelector('[id*="image_with_text_"].shopify-section.section');
      if (imageWithText) imageWithText.style.display = 'block';
    }

    // Hide certain homepage sections
    ['1655309354f41fc552', '1658426449f4e714af', '747ebe95-fc17-40df-8d2f-4eb5e023a3c3', '35b2f5c5-6b20-4edb-8211-6bb84221e676', '1658787851dffd7a2b', '16587876712bc7b830'].forEach(function(id) {
      const section = document.querySelector('[id*="' + id + '"].shopify-section.section');
      if (section) section.style.display = 'none';
    });

    // On non-FitSwitch pages on paradigmiot.com, remove FitSwitch-only nav items
    // FitSwitch pages keep their nav via Liquid + the protection script
    const fitSwitchPaths = ['/blogs/learn', '/products/fitswitch', '/pages/apps', '/pages/instructions',
      '/pages/heart-rate', '/pages/bike-installation', '/pages/bike-plus-installation',
      '/pages/reset-statistics', '/pages/uninstall-apps', '/pages/close-apps', '/pages/kinomap-setup'];
    const isFitSwitchPage = fitSwitchPaths.some(function(p) { return currentPath.indexOf(p) !== -1; });

    if (!isFitSwitchPage) {
      removeNavLink('/pages/apps');
      removeNavLink('/pages/instructions');
    }
  }
  // On fitswitch.io: do nothing extra, Liquid + protection script handles everything


  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icons"] && !Shopify.designMode) return;
  try {
    
  // Silkymitts Redirect
  if (window.location.href.indexOf("shop.silkymittsball.com") !== -1) {
    // Modify href function
    const modifyHref = function (oldHref, newHref) {
      const elements = document.querySelectorAll("a[href='" + oldHref + "']");
      elements.forEach(function (element) {
        element.href = newHref;
      });
    };
  
    // Fix twitter link
    modifyHref("https://twitter.com/fitswitch_io", "https://twitter.com/silkymittsball");
  
    // Fix instagram link
    modifyHref("https://www.instagram.com/thefitswitch/", "https://www.instagram.com/silkymittsball/");
  
    // Fix email link
    modifyHref("mailto:help@fitswitch.io", "mailto:hockey@silkymittsball.com");
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
